const styles = {
  centered: {
    marginTop: 'auto',
    marginBottom: 'auto',
  },
  campaignWrapper: {
    padding: '24px 40px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    '@media screen and (max-width: 600px)': {
      padding: '24px 15px',
    },
  },
  title: {
    fontFamily: "'Proxima Nova', sans-serif",
    fontWeight: 'bold',
    marginBottom: 16,
  },
  emptyStateText: {
    color: '#0C172C',
    fontSize: 16,
    fontWeight: 400,
    marginBottom: 16,
  },
  btnWrapper: {
    width: '100%',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
  },
  btnWrapperMargin: {
    marginTop: '-83px',
  },
  admEmptyStateImage: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    width: '100%',
    height: '100%',
  },
  btnTitle: {
    fontSize: 16,
    lineHeight: '20px',
    color: '#1D2943',
    margin: '40px 0 20px',
  },
  newCampaignBtn: {
    fontFamily: "'Proxima Nova', sans-serif",
    borderRadius: 12,
    backgroundColor: 'rgba(238, 67, 96, 1)',
    color: '#FFFFFF',
    textTransform: 'none',
    border: '1px solid rgba(238, 67, 96, 1)',
    minWidth: '230px',
    padding: '10px 20px',
    fontWeight: 600,
    height: 40,
    fontSize: 16,
    '&:hover': {
      backgroundColor: 'rgba(238, 67, 96, 1)',
    },
    '@media screen and (max-width: 600px)': {
      maxWidth: 340,
      width: '100%',
    },
  },
  campaignDropdownBtn: {
    '@media screen and (max-width: 600px)': {
      width: '100%',
      maxWidth: 340,
    },
    '& button': {
      margin: '0 auto',
      padding: '10px 20px',
      fontWeight: 600,
      height: 40,
      borderRadius: 12,
      '@media screen and (max-width: 600px)': {
        maxWidth: 340,
        width: '100%',
      },
    },
  },
  newCampaignCTAOptionsWrapper: {
    width: '208px',
    position: 'absolute',
    background: '#FFFFFF',
    borderRadius: '8px',
    border: '1px solid #2737541F',
    marginTop: '4px',
    '& > p': {
      padding: '13px 10px',
      lineHeight: '18px',
      cursor: 'default',
      fontWeight: 400,
      color: '#0C172C',
      '&:hover': {
        '&:first-child': {
          borderRadius: '8px 8px 0 0',
        },
        background: '#E2E2FC',
        cursor: 'pointer',
        '&:last-child': {
          borderRadius: '0 0 8px 8px',
        },
      },
    },
  },
}

export default styles
